export const fiscal = {
	fiscalData: "Dados Fiscais",
	validations: {
		number: "Apenas números",
	},
};
